<template>
  <div>
    <el-table
        ref="table"
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        :max-height="maxTableHeight"
        row-key="id"
    >
      <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :reserve-selection="true"
      ></el-table-column>
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
      ></el-table-column>
      <el-table-column label="外销合同编号" width="160" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="加工单位" width="160" prop="factoryName" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品番号" width="160" prop="code" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" width="100" prop="skuCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" align="center" prop="name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" align="center" prop="nameZh" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="color"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="size"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="合同计划数"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="checkInCount"
          label="入库数"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="checkOutCount"
          label="出库数"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="preBoxCount"
          label="每箱入数"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          label="加工费单价"
          header-align="center"
          align="center"
          width="100"
      >
        <template slot-scope="scope">
          {{ moneyFormat(scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column
          label="检品费单价"
          header-align="center"
          align="center"
      >
        <template slot-scope="scope">
          {{ moneyFormat(scope.row.checkAmount) }}
        </template>
      </el-table-column>
      <el-table-column
          label="小计"
          header-align="center"
          align="center"
      >
        <template slot-scope="scope">
          {{ moneyFormat(scope.row.totalAmount) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="needPage"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'MakeDetailTable',
  mixins: [mixinViewModule],
  props: {
    maxTableHeight: {
      type:Number,
      default:400
    },
    needPage: false,
    queryForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorymake/detail/page',
        getDataListIsPage: true,
        activatedIsNeed: false
      },
      dataForm: {}
    }
  },
  watch: {
    needPage: {
      handler: function (newVal) {
        this.$set(this.dataForm, 'needPage', newVal)
      },
      immediate: true
    },
    queryForm: {
      handler: function (newVal) {
        this.dataForm = {
          ...this.dataForm,
          ...newVal
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearSelection(){
      if(this.$refs.table){
        this.$refs.table.clearSelection()
      }
    },
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length === 0) {
        return
      }
      dataList.forEach(item => {
        if (!item.checkAmount) {
          item.checkAmount = 0
        }
        if (!item.amount) {
          item.amount = 0
        }
        item.totalAmount = (item.amount + item.checkAmount) * item.count
      })
    }
  }
}
</script>

<style scoped>

</style>
